import { useDispatch, useSelector, useStore } from 'react-redux';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { changeCategory, changeThumbnail, setDraftSequence, setTags, updateTitleAndContent } from '../../actions/post';
import { getEditorContent, setEditorContent } from '../../lib/PostUtils';
import { formatDateTimeString } from '../../lib/DateUtils';
import { toggleFooterStatusText, updateFooterStatusText } from '../../actions';
import dateFormat from 'dateformat';
import { findCategoryById } from '../../lib/CategoryUtils';

export function postAutosaveData (title, content, tags, categoryId, thumbnail, draftSequence = null) {
  return axios.post(`${appInfo.manageUrl}/autosave`, {
    title,
    content,
    tags,
    draftSequence,
    categoryId,
    thumbnail,
  });
}

function getAutosaveData () {
  return axios.get(`${appInfo.manageUrl}/autosave`);
}

/**
 * @return {null}
 */
export default function AutosaveController () {
  const store = useStore();
  const post = useSelector(state => state.post);
  const categories = useSelector(state => state.blog.categories);
  const editorInitialized = useSelector(state => state.env.editorInitialized);
  const dispatch = useDispatch();

  let lastTitle = '';
  let lastContent = '';
  let lastTags = '';
  let lastCategoryId = 0;
  let lastThumbnail = '';

  // 수정 모드인 경우 자동저장을 실행하지 않는다.
  if (post.orgPost && post.orgPost.id) {
    return null;
  }

  function setEditorCategoryId (categoryId) {
    const matchCategory = findCategoryById(categories, categoryId);

    if (!matchCategory) {
      dispatch(changeCategory(0, null));
      return;
    }

    dispatch(changeCategory(matchCategory.id, matchCategory.viewChannel));
  }

  const showStatusText = (text, duration) => {
    dispatch(updateFooterStatusText(text));
    dispatch(toggleFooterStatusText(true));

    setTimeout(() => {
      dispatch(toggleFooterStatusText(false));

      // css 트랜지션 시간동안 텍스트 유지
      setTimeout(() => {
        dispatch(updateFooterStatusText(''));
      }, 2000);
    }, duration);
  };

  const autosaveHandler = () => {
    const post = store.getState().post.newPost;
    const content = getEditorContent(store.getState().env.editorMode);
    const tags = post.tags.join(',');

    // 타이틀과 컨텐츠 둘다 비었을때는 저장 x
    if (post.title.trim() === '' && content.trim() === '') {
      return;
    }

    // 변경사항이 없을떄는 저장 x
    if (post.title === lastTitle &&
      content === lastContent &&
      tags === lastTags &&
      post.category === lastCategoryId &&
      post.thumbnail === lastThumbnail) {
      return;
    }

    lastTitle = post.title;
    lastContent = content;
    lastTags = tags;
    lastCategoryId = post.category;
    lastThumbnail = post.thumbnail;

    postAutosaveData(post.title, content, tags, post.category, post.thumbnail, store.getState().post.draftSequence || null).then(() => {
      showStatusText(`자동 저장 완료 ${dateFormat(Date.now(), 'HH:MM')}`, 4000);
    });
  };

  const autosaveLoader = () => {
    if (!editorInitialized) {
      return;
    }

    getAutosaveData().then(res => {
      if (!res.data.autosavedEntry) {
        return;
      }

      const autosaved = res.data.autosavedEntry;

      const result = confirm(`${formatDateTimeString(autosaved.createdAt)}에 자동저장된 글이 있습니다. \n이어서 작성하시겠습니까?`);

      if (!result) {
        return;
      }

      lastTitle = autosaved.title;
      lastContent = autosaved.content;
      lastTags = autosaved.tags;
      lastCategoryId = autosaved.categoryId;
      lastThumbnail = autosaved.thumbnail;

      dispatch(updateTitleAndContent(autosaved.title, autosaved.content));

      if (window.activeEditor) {
        setEditorContent(store.getState().env.editorMode, autosaved.content);
      }

      if (autosaved.draftSequence) {
        dispatch(setDraftSequence(autosaved.draftSequence));
      }

      if (autosaved.tags) {
        dispatch(setTags(autosaved.tags.split(',')));
      }

      if (autosaved.thumbnail) {
        dispatch(changeThumbnail(autosaved.thumbnail));
      }

      setEditorCategoryId(autosaved.categoryId);
    });
  };

  // 컴포넌트 마운트시 자동저장된 글이 있는지 확인 후 데이터를 불러와 redux store에 저장한다.
  useEffect(autosaveLoader, [editorInitialized]);

  // 컴포넌트 마운트시 autosave 핸들러를 60초마다 실행하도록 타이머에 등록한다.
  useEffect(() => {
    if (!editorInitialized) {
      return;
    }

    const timer = setInterval(autosaveHandler, 10000);

    return () => {
      clearInterval(timer);
    };
  }, [editorInitialized]);

  return null;
}
